import Nav from "components/Nav";
import MultiActionAreaCard from "components/Card";
import React from "react";

function EcommerceDashboard() {
  const [keyword, setKeyword] = React.useState("");

  return (
    <>
      <Nav onSearch={setKeyword} />
      <div className="main-content" style={{ padding: "2%" }}>
        <MultiActionAreaCard search={keyword} />
      </div>
    </>
  );
}

export default EcommerceDashboard;
